import * as React from 'react';
import findKey from 'lodash/findKey';
import Footer from 'app/components/FooterComponent';
import Header from 'app/components/HeaderComponent';
import ModuleSelectorComponent from '__common/components/moduleSelector/moduleSelectorComponent';
import OtherUserSettings from 'userPreferences/components/otherUserSettings';
import UpdateButton from 'userPreferences/components/updateButton';
import { connect } from 'react-redux';
import { loadDefaultModule } from '__common/components/moduleSelector/moduleSelector';
import { getProductName, products } from '__common/constants/products';
import { Select, MenuItem, InputAdornment, IconButton, FormControl, InputLabel } from '@mui/material';
import { Checkbox } from '@mui/material';
import { TextField } from '@mui/material';
import { SET_USER_ZIPCODE, SET_AREA, SET_USER_RAFTER_SPACING } from 'userPreferences/userPreferencesActions';
import {
  SET_USER_HELIOSCOPE,
  SET_USER_HELIOSCOPE_LOGIN,
  SET_USER_HELIOSCOPE_PASSWORD,
  SET_USER_SPANS,
  SET_STAGGER_ATTACHMENTS,
} from 'actions';
import rafterSpacing from 'projectDesign/components/projectConfiguration/fields/rafterSpacing';
import { getAreaByZip } from '__editor/components/roofsSelector/components/roofsSelectorMap/utils/getAreaByZip';
import { ICITY_STATE } from '__editor/components/roofsSelector/components/roofsSelectorMap/utils/cityModel';
import { Visibility, VisibilityOff } from '@mui/icons-material';

type Props = {
  dispatch: Function;
  moduleSelector: moduleSelectorState;
  userPreferences: userPreferencesState;
};

class UserPreferences extends React.Component<Props, {showPassword: boolean}> {
  constructor(props){
    super(props)
    this.state={
      showPassword: false
    }
  }
  validationTimeout;

  UNSAFE_componentWillMount() {
    loadDefaultModule(getProductName(9));
  }

  setZipcode = (zipcode: string) => {
    const { dispatch } = this.props;
    dispatch(SET_USER_ZIPCODE(zipcode));
    if (zipcode && zipcode.length === 5) {
      this.updateCityName(zipcode);
    }
  }

  handleClickShowPassword = () => {
    this.setState({showPassword: !this.state.showPassword})
  }

  updateCityName = (zipCode: string) => {
    const { dispatch } = this.props;
    getAreaByZip(zipCode, (data: ICITY_STATE) => dispatch(SET_AREA(`${data.city}, ${data.state}`)));
  }

  helioscopeCredentials = () => {
    const {
      userPreferences: {
        helioscope_username,
        helioscope_password,
        helioscope_user,
      },
    } = this.props;
    const visibility = helioscope_user ? 'visible' : 'hidden';
    return (
      <div className="helioscope-credentials" style={{ visibility }}>
        <TextField
          id="heliscope-user-login"
          label="HELIOSCOPE USERNAME"
          variant='standard'
          placeholder="Type helioscope login"
          value={helioscope_username || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.setHelioscopeLogin(event.target.value)}
        />
        <TextField
          type={this.state.showPassword ? 'text' : 'password'}
          id="helioscope-user-password"
          variant='standard'
          label="HELIOSCOPE PASSWORD"
          placeholder="Type helioscope password"
          value={helioscope_password || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.setHelioscopePassword(event.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={this.handleClickShowPassword}
                  edge="end"
                >
                  {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>
    );
  }

  enableHelioscopeUser = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { dispatch } = this.props;
    dispatch(SET_USER_HELIOSCOPE(event.target.checked));
  }

  setHelioscopeLogin = (login: string) => {
    const { dispatch } = this.props;
    dispatch(SET_USER_HELIOSCOPE_LOGIN(login));
  }

  setHelioscopePassword = (password: string) => {
    const { dispatch } = this.props;
    dispatch(SET_USER_HELIOSCOPE_PASSWORD(password));
  }

  setSpans = (spans: number) => {
    const { dispatch } = this.props;
    dispatch(SET_USER_SPANS(spans));
  }

  setRafterSpacing = (rafterSpacing: number) => {
    const { dispatch } = this.props;
    dispatch(SET_USER_RAFTER_SPACING(Number(rafterSpacing)));

    if (this.validationTimeout) {
      clearTimeout(this.validationTimeout);
    }

    this.validationTimeout = setTimeout(() => {
      this.validateRafterSpacing(rafterSpacing);
      clearTimeout(this.validationTimeout);
    }, 2000);
  }

  validateRafterSpacing = (rafterSpacingVal) => {
    const { dispatch } = this.props;

    if (rafterSpacingVal < rafterSpacing().min) {
      dispatch(SET_USER_RAFTER_SPACING(1));
    } else if (rafterSpacingVal > rafterSpacing().max) {
      dispatch(SET_USER_RAFTER_SPACING(144));
    }
  }

  setStaggerAttachments = (stagger_attachments: number) => {
    const { dispatch } = this.props;
    if (stagger_attachments) {
      dispatch(SET_STAGGER_ATTACHMENTS(Boolean(true)));
    } else {
      dispatch(SET_STAGGER_ATTACHMENTS(Boolean(false)));
    }
  }

  renderError() {
    const {
      userPreferences: { error },
    } = this.props;
    let errorDiv;
    if (error !== null) {
      if (error['non_field_errors']) {
        errorDiv = (
          <div className="input-warning">{error['non_field_errors']}</div>
        );
      }
    }

    return errorDiv;
  }

  render() {
    const {
      moduleSelector: {
        modelData: { width, height, thickness },
      },
      userPreferences: {
        zipcode,
        product,
        helioscope_user,
        preferred_span,
        stagger_attachments,
        rafter_spacing_inches,
        area,
      },
    } = this.props;

    return (
      <div className="app-content">
        <Header />
        <div className="user-preferences">
          <div className="user-settings">
            <div className="main-title">
              Default Values for New Projects
            </div>
            <ModuleSelectorComponent
              dispatch={this.props.dispatch}
              noTitle={true}
              noCustomModule={true}
              fullSelectWidth={true}
              productId={findKey(products, val => val === product)}
              hideSameDimsButton={true}
              hideRefreshButton={true}
            />
            {this.renderError()}
            <div className="settings">
              <div className="panels-settings">
                <FormControl >
                  <TextField
                    id="zipcode"
                    label="ZIPCODE"
                    variant='standard'
                    placeholder="Type zipcode"
                    value={zipcode}
                    fullWidth
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.setZipcode(event.target.value)}
                  />
                </FormControl>
                <FormControl fullWidth >
                  <InputLabel id='stagger-attachment'>STAGGER ATTACHMENT</InputLabel>
                  <Select
                    label="STAGGER ATTACHMENT"
                    name="stagger-attachment"
                    aria-label="stagger-attachment"
                     variant='standard'
                    labelId="stagger-attachment"
                    fullWidth
                    value={stagger_attachments ? '1' : '0'}
                    onChange={(e) => this.setStaggerAttachments(e.target.value === "1" ? 1 : 0)}
                    MenuProps={{
                      anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                      transformOrigin: { vertical: 'top', horizontal: 'left' },
                    }}
                  >
                    {
                      ([
                        { label: 'YES', value: '1' },
                        { label: 'NO', value: '0' },
                      ]).map((item, index) => (
                        <MenuItem
                          key={index}
                          value={item.value}
                        >
                          {item.label || 'label'}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth >
                  <TextField
                    label="SPAN"
                    type="number"
                     variant='standard'
                    id="spans"
                    placeholder='Type spans'
                    value={String(preferred_span) || ''}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.setSpans(Number(event.target.value))}
                  />
                </FormControl>
                <FormControl fullWidth >
                  <TextField
                    label="RAFTER SPACING"
                    placeholder="Type rafter spacing"
                    name="rafter_spacing"
                     variant='standard'
                    aria-label="rafter_spacing"
                    id="rafter_spacing"
                    type="number"
                    min={1}
                    max={144}
                    value={String(rafter_spacing_inches)}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.setRafterSpacing(Number(event.target.value))}
                  />
                </FormControl>
              </div>
              <OtherUserSettings />
            </div>
            <div className="helioscope-user-checkbox">
              <div className="input-label">HELIOSCOPE USER</div>
              <Checkbox
                id="helioscope-user-checkbox"
                name="helioscope-checkbox"
                aria-label="helioscope-checkbox"
                checked={helioscope_user}
                onChange={this.enableHelioscopeUser}
                disableRipple
                sx={{
                  padding: 0,
                  margin: 0,
                  alignSelf: 'flex-start',
                  color: '#ff9800',
                  '&.Mui-checked': {
                    color: '#ff9800',
                  },
                }}
              />
            </div>
            {this.helioscopeCredentials()}
            <UpdateButton />
          </div>
          <div className="user-preview">
            <div className="main-title">Preferences status</div>
            <div className="details">
              <div className="detail">
                <div className="label">CITY, STATE</div>
                <div className="value">{area}</div>
              </div>
              <div className="detail">
                <div className="label">MODEL WIDTH</div>
                <div className="value">
                  {width}{width ? '"' : ''}
                </div>
              </div>
              <div className="detail">
                <div className="label">MODEL LENGTH</div>
                <div className="value">
                  {height}{height ? '"' : ''}
                </div>
              </div>
              <div className="detail">
                <div className="label">MODEL THICKNESS</div>
                <div className="value">
                  {thickness}{thickness ? '"' : ''}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(appState: appState) {
  return {
    userPreferences: appState.userPreferences,
    moduleSelector: appState.moduleSelector,
  };
}

export default connect(mapStateToProps)(UserPreferences);
